<template>
    <v-dialog transition="scale-transition" origin="center center" max-width="463" v-model="dialog" content-class="">
        <template v-slot:activator="{ on, attrs }">
            <v-btn :ripple="false" v-bind="attrs" v-on="on" tile elevation="0" class="custom-btn mr-0 px-2" height="39"
                color="#039de9">
                Add New Contest
            </v-btn>
        </template>
        <v-stepper v-model="e1" class="password-stepper admin-password-stepper">
            <v-stepper-header class="d-none">
                <v-stepper-step :complete="e1 > 1" step="1" color="greenMain">
                    General info
                </v-stepper-step>
                <v-stepper-step step="2" color="#708AA7">
                    Email & Password
                </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1" class="pa-0">
                    <v-card class="deposit-form create-account-form"
                        :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                        <v-row dense>
                            <v-card class="rounded-0 pa-7"
                                :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                                <v-card-title class="pb-1 pt-0 text-left justify-start pl-3">
                                    Add Contest
                                </v-card-title>
                                <v-card-subtitle class="mt-0 pl-3 pb-4 pr-10 text--ash">
                                    You Can Add Contest From Here
                                </v-card-subtitle>
                                <v-card class="deposit-form px-3 py-4"
                                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                                    <v-row>
                                        <v-col cols="12">
                                            <fieldset class="mb-0">
                                                <legend>Contest Name</legend>
                                                <v-text-field v-model="formData.contest_name" label="Write Contest Name"
                                                    single-line solo hide-details class="custom-select">
                                                </v-text-field>
                                            </fieldset>
                                        </v-col>
                                        <v-col cols="12">
                                            <fieldset class="mb-0">
                                                <legend>Deposit Amount</legend>
                                                <v-text-field v-model="formData.contest_money" label="Enter Amount ($)"
                                                    type="number" single-line solo hide-details class="custom-select">
                                                </v-text-field>
                                            </fieldset>
                                        </v-col>
                                        <v-col cols="12">
                                            <fieldset class="mb-0">
                                                <legend>
                                                    Start Time - End Time
                                                </legend>
                                                <v-dialog ref="dialog" v-model="modal" :return-value.sync="dateRange"
                                                    width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="selectedDatesText"
                                                            prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                                                            readonly v-bind="attrs" v-on="on" solo class="custom-select"
                                                            label="Date Range"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="selectedDates" class="custom-date-picker"
                                                        scrollable range>
                                                        <v-spacer></v-spacer>
                                                        <v-btn text @click="cancelSelection">Cancel</v-btn>
                                                        <v-btn text @click="confirmSelection">OK</v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </fieldset>
                                        </v-col>
                                        <v-col cols="12">
                                            <fieldset class="mb-0">
                                                <legend>Prize Type</legend>
                                                <v-select v-model="formData.prize_type" solo :items="prizeTypes"
                                                    item-text="text" item-value="value" append-icon="mdi-chevron-down"
                                                    label="Click to Select" class="custom-select" hide-details>
                                                </v-select>
                                            </fieldset>
                                        </v-col>

                                        <v-col cols="12" v-for="(prize, index) in formData.prizes" :key="index">
                                            <fieldset class="mb-0">
                                                <legend>No. {{ index + 1 }} Prize</legend>
                                                <v-text-field v-model="formData.prizes[index]"
                                                    :label="formData.prize_type === 0 ? '$' : 'Prize Item'" single-line
                                                    solo hide-details class="custom-select">
                                                </v-text-field>
                                            </fieldset>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-row dense>
                                                <v-col cols="6" md="6">
                                                    <v-btn class="text-capitalize mb-0" @click="addPrize"
                                                        :ripple="false" tile block outlined elevation="0"
                                                        color="#039de9">
                                                        + More Prize
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="6" md="6">
                                                    <v-btn :disabled="formData.prizes.length === 1" @click="removePrize"
                                                        :ripple="false" tile block outlined elevation="0"
                                                        color="#FF567F" class="text-capitalize mb-0">
                                                        Delete Last Prize
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12">
                                            <fieldset class="mb-0">
                                                <legend>Total Prize Worth</legend>
                                                <v-text-field v-model="formData.total_prize_worth"
                                                    label="Enter Amount ($)" type="number" single-line solo hide-details
                                                    class="custom-select">
                                                </v-text-field>
                                            </fieldset>
                                        </v-col>
                                        <v-col cols="12">
                                            <fieldset class="mb-0">
                                                <legend>Account Type</legend>
                                                <v-select v-model="formData.account_type_id"
                                                    item-text="account_type_display" item-value="id" solo
                                                    :items="allacctypes" append-icon="mdi-chevron-down"
                                                    label="Click to Select" class="custom-select" hide-details>
                                                </v-select>
                                            </fieldset>
                                        </v-col>
                                        <v-col cols="12">
                                            <fieldset class="custom-textarea mb-0">
                                                <legend>Instruction</legend>
                                                <v-textarea v-model="formData.instruction" height="80px"
                                                    class="custom-select" single-line solo hide-details
                                                    label="Write Here">
                                                </v-textarea>
                                            </fieldset>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card-actions>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-btn block @click="closeDialog" :ripple="false" tile elevation="0"
                                                class="custom-btn" color="#FF567F">
                                                Close
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn @click="handleSubmit" block :ripple="false" tile elevation="0"
                                                class="custom-btn" color="#039de9">
                                                Create Contest
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-row>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="2" class="pa-0">
                    <v-row dense>
                        <v-card class="deposit-form congratulation pa-10"
                            :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                            <v-img class="mx-auto" width="201" height="193" src="@/assets/amico.png"></v-img>
                            <v-card-title class="justify-center mt-8 mb-6">Congratulations</v-card-title>
                            <v-card-subtitle class="text-center">
                                Contest Created Successfully
                            </v-card-subtitle>
                            <v-card-actions class="justify-center">
                                <v-btn @click="closeDialog" :ripple="false" tile elevation="0" class="custom-btn px-16"
                                    color="#039de9">
                                    Done
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CONTEST__ACTIONS } from "@/store/action-types";
import toast from '@/services/Notification';

export default {
    name: 'AddContestModal',
    data() {
        return {
            dialog: false,
            modal: false,
            selectedDates: [],
            selectedDatesText: null,
            e1: 1,
            prizeTypes: [
                { text: 'Amount', value: 0 },
                { text: 'Prize', value: 1 }
            ],
            formData: {
                contest_name: '',
                contest_money: 0,
                start_date: '',
                end_date: '',
                prize_type: 0,
                prizes: [''],
                account_type_id: null,
                instruction: '',
                total_prize_worth: 0,
            }
        }
    },

    computed: {
        ...mapState("contest", ["allacctypes"]),
    },

    methods: {
        ...mapActions("contest", [CONTEST__ACTIONS.CREATECONTEST, CONTEST__ACTIONS.GETALLCONTESTACCTYPES]),

        addPrize() {
            if (this.formData.prizes.length > 2) {
                toast.error("You can't add more than 3 prizes")
                return;
            }
            this.formData.prizes.push("");
        },
        removePrize() {
            if (this.formData.prizes.length > 1) {
                this.formData.prizes.pop();
            }
        },

        closeDialog() {
            this.dialog = false;
            this.e1 = 1;
        },

        async handleSubmit() {
            const hasValidPrizes = () =>
                this.formData.prizes.some(prize => prize !== null && prize !== undefined && prize.trim() !== '');
            if (!this.formData.contest_name) {
                toast.error("Contest name field is required")
                return;
            }

            if (!this.formData.contest_money) {
                toast.error("Deposit amount field is required")
                return;
            }

            if (!this.formData.start_date) {
                toast.error("Contest start date field is required")
                return;
            }

            if (!this.formData.end_date) {
                toast.error("Contest end date field is required")
                return;
            }
            if (!hasValidPrizes()) {
                toast.error("Please add prize for the contest")
                return;
            }

            const result = await this[CONTEST__ACTIONS.CREATECONTEST]({
                ...this.formData
            })

            if (result && result.success) {
                this.e1 = 2;
            }

            this.formData = {
                contest_name: '',
                contest_money: 0,
                start_date: '',
                end_date: '',
                prize_type: 0,
                prizes: [],
                account_type_id: null,
                instruction: '',
                total_prize_worth: 0,
            }
        },

        getCurrentDate() {
            const currentDate = new Date();
            const formattedDate = currentDate.toISOString().split("T")[0];
            return formattedDate;
        },

        cancelSelection() {
            this.modal = false;
        },

        confirmSelection() {
            if (this.selectedDates.length !== 2) {
                toast.error("Both start and end dates must be selected");
                return;
            }

            let startDate = new Date(this.selectedDates[0]);
            let endDate = new Date(this.selectedDates[1]);

            if (startDate > endDate) {
                [startDate, endDate] = [endDate, startDate];
            }

            this.formData.start_date = startDate
            this.formData.end_date = endDate

            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            // Update the display text
            this.selectedDatesText = `${formatDate(startDate)} ~ ${formatDate(endDate)}`;
            this.modal = false;
        },
    },
    async mounted() {
        await this[CONTEST__ACTIONS.GETALLCONTESTACCTYPES]();
        this.selectedDatesText = [
            this.getCurrentDate(),
            this.getCurrentDate(),
        ].join(" ~ ");
    },
}
</script>